<!--
 * @Author: Tina Huang
 * @Date: 2023-06-27 14:14:54
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2023-06-30 21:57:19
 * @Description: 
-->
<template>
  <div :class="['container', titleFixed ? 'hasfix' : '']">
    <div :class="['menu', titleFixed ? 'fixed' : '']">
      <div
        :class="['menu-item', widType === item.key ? 'active' : '']"
        v-for="item in menus"
        :key="item.key"
        @click="handleMenu(item)"
      >
        {{ item.label }}
      </div>
    </div>
    <div
      class="item-card"
      v-for="(item, index) in currentList"
      :key="index"
      @click="handleCreate(item)"
    >
      <img :src="item.cover" alt="" class="image" />
      <span
        :id="`#/create/${item.id}/time`"
        class="leancloud_visitors clearfix"
        :data-flag-title="item && item.tag"
      >
        <i class="leancloud-visitors-count"></i>
      </span>
      <div class="bottom clearfix">
        <h3>{{ item.tag }}</h3>
        <span class="datetime-tag">{{ item.timestamp | relative }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show_setting_modal: false,
      currentItem: null,
      currentComponent: "highlight",
      list: {},
      widType: "resources",
      currentList: [],
      titleFixed: false,
      menus: [
        {
          label: "🕙 时间组件",
          key: "resources",
        },
        {
          label: "💪 效率组件",
          key: "efficiency",
        },
        {
          label: "🔧 其他组件",
          key: "others",
        },
      ],
    };
  },
  mounted() {
    this.getDatas();
    window.addEventListener("scroll", this.calcScroll);
  },
  methods: {
    getDatas() {
      const _this = this;
      this.$axios
        .get(`./${this.widType}.json?v=${Math.random()}`)
        .then((res) => {
          let times = res.data.list.filter((item) => !item.hide);
          _this.list[_this.widType] = times;
          _this.currentList = times;
        });
    },
    handleCreate(item) {
      console.log("......");
      if (item.extra_link) {
        return window.open(item.extra_link);
      }
      const id = item.id;
      splitbee.track("Select widget in mobile", {
        type: "time",
        id,
      });
      // window.location.href = `/#/create/${id}/time`;
      // return
      this.$router.replace(`/mcreate/${id}/${this.widType}`);
    },
    handleSettingModal(item) {
      if (item.link_type !== "setting") return;
      this.currentItem = item;
      this.currentComponent = item.link;
      this.show_setting_modal = true;
    },
    handleModalClose() {
      this.currentItem = null;
      this.currentComponent = null;
      this.show_setting_modal = false;
    },
    calcScroll() {
      let self = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.getElementById("site-header").offsetHeight;
      self.titleFixed = scrollTop > offsetTop;
    },
    handleMenu(item) {
        if(this.widType !== item.key) {
            this.widType = item.key
            if(!this.list[item.key] || this.list[item.key].length === 0) {
                this.getDatas()
            } else {
                this.currentList = this.list[item.key];
            }
        }
    }
  },
};
</script>
<style lang="less" scoped>
.container {
  background: #ffffff;
  position: relative;
  z-index: 1;
  margin-top: 20px;
  &.hasfix {
    padding-top: 85.5px;
  }
}
.item-card {
  width: 330px;
  margin: 0 auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  border-radius: 10px;
  padding-bottom: 10px;
}
.menu {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  padding: 20px;
  padding-top: 0;
  box-sizing: border-box;
  font-size: 14px;

  &.fixed {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 2;
    padding-top: 20px;
  }

  &-item {
    padding: 10px;
    &.active {
      border-radius: 25px;
      border: 1px solid #000;
    }
  }
}
</style>
